import React, { useLayoutEffect, useRef } from 'react'
import { Provider as StoreProvider } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ModalProvider } from 'view/shared/modal'
import { ErrorBoundary } from 'view/shared/error/ErrorBoundary'
import { createStore } from 'createStore'
import { getConfig } from 'configurationLoader'
import { SelectionActions } from 'store/selection'
import { ShellBrowser, Main, Tearout } from 'view/shell'
import { NavigateEventListener } from 'NavigateEventListener'
import { QUOTE_APP_BASE_URL } from './constants'

export const AppBrowser = () => {
  const storeRef = useRef(createStore(getConfig()))

  useLayoutEffect(() => {
    storeRef.current.dispatch(SelectionActions.initialiseWindow({}))
  }, [])

  return (
    <StoreProvider store={storeRef.current}>
      <ErrorBoundary>
        <ModalProvider>
          <BrowserRouter basename={QUOTE_APP_BASE_URL}>
            <NavigateEventListener />
            <ShellBrowser>
              <Routes>
                <Route path="/tearout/*" element={<Tearout />} />
                <Route path="*" element={<Main />} />
              </Routes>
            </ShellBrowser>
          </BrowserRouter>
        </ModalProvider>
      </ErrorBoundary>
    </StoreProvider>
  )
}
